
import {  Tabs } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import styles from './index.module.scss';

export const pageTabs = [
  {id: 'TronDeposit', title: 'USDT购买V币',  url: '/root/crypto_trading?type=1'},
  {id: 'ChangeUsdt', title: 'V币兑换USDT', url: '/root/crypto_trading?type=2' },
]

export const FormTabs = (props: {active: string}) => {
  const navigate = useNavigate();
  const onChange = (activeKey:string) =>  {
    
    const tab = pageTabs.find(tab => tab.id === activeKey);
    if(tab){
      navigate(tab.url, {replace: true});
    }
  }
  return <Tabs  activeKey={props.active} onChange={onChange} className={styles.tabs}>
  {pageTabs.map((Tab) => {
    return <Tabs.Tab title={Tab.title} key={Tab.id} destroyOnClose />;
  })}
</Tabs>
}